import React 		from 'react';
import ReactDOM 	from 'react-dom';
import Dispatcher 	from './Dispatcher';
import assign 		from 'object-assign';

var FeedbackDispatcher 	=	assign( new Dispatcher(), {

	handleViewAction 	: 	function( action ) {

		this.dispatch({

			source 	: 	'VIEW_ACTION',
			action 	: 	action

		})
	}
});

export default	FeedbackDispatcher; 






// WEBPACK FOOTER //
// ./resources/assets/js/data-feed/dispatcher/FeedbackDispatcher.js